import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'

// import { connect, useDispatch, useSelector } from 'react-redux';
import { showAppLoader, hideAppLoader } from '../app';

export const locationList = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/corporate/location/list', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};
export const locationDetail = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('/user/corporate/location/' + data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());

      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};
export const addLocation = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/corporate/location/add', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());

      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};
export const updateLocation = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/corporate/location/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};
export const updateSubAccount = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/corporate/location/sub-account/update', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const resentInvitation = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/notification/sub-account/invite', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const subAccountActivation = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/users/sub-account-activation', data, {
      headers: {
        token: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};
export const corporateLocationList = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('user/corporate/location/list', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (typeof ex == 'string') {
        return { ex: { message: ex } };
      }
      return ex;
    });
};

export const manageAccount = (token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .get('user/corporate/manage-account', {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const uploadExcelFile = (formData, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('user/corporate/location/uploadExcel', formData, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const purchasingLimit = (locationId, formData, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('user/location/reset/purchasing/limit/' + locationId, formData, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const editPurchasingLimit = (locationId, data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('user/location/edit/purchasing/limit/' + locationId, data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader())
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const locationDeactivate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/corporate/location/deactivate', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const locationActivate = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/corporate/location/activate', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const locationDelete = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/user/corporate/location/delete', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};


